const Element = require("components/abstract/Element");
const React = require("react");
const PropTypes = require("prop-types");

class BaseRow extends Element {

    static get propTypes() {
        return {
            data: PropTypes.any,
            label: PropTypes.string,
            greedyClick: PropTypes.bool,
        };
    }

    static get defaultProps() {
        return {
            data: [],
            label: null,
            greedyClick: false
        };
    }

    get data() {
        return this.props.data;
    }

    get has_data() {
        return this.data !== null && Object.values(this.data).length > 0;
    }

    get templates() {
        return React.Children.toArray(this.props.children);
    }

    get defaultClassNames() {
        return [
            this.action ? 'has-action' : null,
            this.rowClass(),
            (this.has_data && typeof(this.data.getStore) === 'function' && this.data.getStore().isFrozen(this.data.id))?'is-frozen':''
        ];
    }

    get action() {
        const {action} = this.props;

        return (action && typeof action === 'function') ?
            action :
            null;
    }

    rowClass() {
        const {rowClass} = this.props;

        if (!rowClass || typeof rowClass !== 'function') return null;

        return rowClass(this.data);
    }

    mainAction(data) {
        return (e) => {
            const {target} = e;
            const classList = target.className.split(' ');
            const blacklist = el => ['id', 'options'].includes(el);

            if (this.props.greedyClick === false && (target.tagName !== 'TD' || classList.some(blacklist))) return;

            if (this.action) this.action(data);
        }
    }

    renderItems() {
        if (!this.has_data) {
            return null;
        }

        return (
            <tr className={this.classNames} onClick={this.mainAction(this.data)} >
                {this.templates.map(template => {
                    return React.cloneElement(template, {data_index: this.props.data_index, data: this.data});
                })}
            </tr >
        );
    }

    render() {
        return this.renderItems();
    }

}

module.exports = BaseRow;
